import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    @media screen {
      align-items: center;
    }
  `,
  content: css`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0px 20px 8px 12px;
    color: ${colors.prussian};
    flex: 1 1 auto;
    display: flex;
    flex-flow: column nowrap;
    max-width: 812px;
  `,
  form: css`
    margin-top: 3rem;
    width: 100%;
    height: 100%;
  `,
  buttonWrapper: css`
    margin-top: 2rem;
  `,
  btnSubmit: css`
    width: auto !important;
  `,
  input: css`
    width: 100%;
    margin-top: 2rem;
  `,
  forgotLink: css`
    float: right;
    &,
    &:hover {
      color: ${colors.jungle};
      text-decoration: none;
    }
  `,
  getStarted: css`
    color: ${colors.slate};
  `,
  getStartedLinkIntro: css`
    color: ${colors.prussian};
  `,
  getStartedLink: css`
    color: ${colors.jungle};
    text-decoration: underline;
    &:hover {
      color: #c5e8c9;
    }
  `,
  linkWrapper: css`
    margin-top: 32px;
  `,
  header: css`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 16px 0px;
  `,
  selectOption: css`
    padding: 6px 16px !important;
    display: grid !important;
    justify-content: flex-start !important;
  `,
};

export default styles;
